import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('ui-components-MediaRecorder', [
  'panel',
  'status',
  'timer',
  'livePreview',
  'levelMeter',
  'playback',
  'startButton',
  'pauseButton',
  'resumeButton',
  'stopButton',
  'saveButton',
  'recordAgainButton',
  'discardButton',
  'cancelButton',
  'retryButton',
  'recordAudioButton',
  'recordVideoButton',
]);
